import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';

const ServicesPage: React.FC = () => {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Training Services</h1>
          <p className="subtitle">Elite 1-on-1 Coaching Tailored to Your Position</p>
        </div>
      </section>

      <section className="services-content">
        <div className="container">
          <div className="services-intro">
            <h2>Training Sessions</h2>
            <p>
              Every Xcelerate training session is designed to maximize your development. We combine technical 
              skill work with film study, mental preparation, and game strategy to create complete players.
            </p>
          </div>

          <div className="session-description">
            <div className="session-card">
              <h3>What a Typical 2-Hour Session Includes:</h3>
              <ul className="session-features">
                <li>✓ Position-specific technical training</li>
                <li>✓ Footwork and technique development</li>
                <li>✓ Film study and game film breakdown</li>
                <li>✓ Strength and conditioning guidance</li>
                <li>✓ Mental game coaching and strategy</li>
                <li>✓ Learn to read defensive/offensive schemes</li>
                <li>✓ Personalized feedback and goal setting</li>
                <li>✓ Progress tracking and development plan</li>
              </ul>
              <div className="session-note">
                <p><strong>Special rates available for Bellevue East players.</strong></p>
                <p>Contact Coach Mesa to discuss your goals and training options.</p>
              </div>
              <div className="session-cta">
                <Link to="/contact" className="btn btn-primary">Contact Coach Mesa</Link>
                <a href="tel:530-788-5017" className="btn btn-secondary">Call: 530-788-5017</a>
              </div>
            </div>
          </div>

          <div className="positions-section">
            <h2>Position Focus</h2>
            <div className="positions-grid">
              <div className="position-card">
                <div className="position-icon">🛡️</div>
                <h3>Offensive Line</h3>
                <p>Pass protection, run blocking, footwork, hand placement, leverage techniques</p>
              </div>
              <div className="position-card">
                <div className="position-icon">⚡</div>
                <h3>Defensive Line</h3>
                <p>Pass rush moves, gap control, hand fighting, get-off techniques, pursuit angles</p>
              </div>
              <div className="position-card">
                <div className="position-icon">🎯</div>
                <h3>Tight End</h3>
                <p>Blocking fundamentals, route running, catching, release techniques, dual-threat skills</p>
              </div>
              <div className="position-card">
                <div className="position-icon">💨</div>
                <h3>Running Back</h3>
                <p>Vision and reads, footwork, pass protection, receiving skills, ball security</p>
              </div>
            </div>
          </div>

          <div className="scholarship-section">
            <h2>🎓 Scholarship Opportunities</h2>
            <p>
              We believe every athlete deserves access to elite training, regardless of financial circumstances. 
              Low-income scholarships are available for qualified athletes. Don't let cost be a barrier to your development.
            </p>
            <Link to="/contact" className="btn btn-primary">Inquire About Scholarships</Link>
          </div>

          <div className="age-group-section">
            <h2>Who We Train</h2>
            <div className="age-info">
              <div className="age-box">
                <h3>8th - 12th Grade</h3>
                <p>All positions welcome</p>
                <p className="age-note">Athletes of all skill levels - from beginners to varsity starters</p>
              </div>
            </div>
          </div>

          <div className="booking-cta">
            <h2>Ready to Get Started?</h2>
            <p>Limited spots available. Book your session today.</p>
            <div className="booking-buttons">
              <a href="tel:530-788-5017" className="btn btn-primary">Call: 530-788-5017</a>
              <a href="https://x.com/CoachMesa" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">DM @CoachMesa</a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Xcelerate Private Coaching. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default ServicesPage;

